import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { withAuth } from "./withAuth";
import Header from "../components/Header";
import { Button, Flex, Text, Card, Image } from "@mantine/core";
import { Link } from "react-router-dom";
import { API_URL } from "../config";

function ProfilePage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const userId = localStorage.getItem("userId");

  useEffect(() => {
    axios
      .get(`${API_URL}/users/${userId}`)
      .then((response) => {
        setName(response.data.data.name);
        setEmail(response.data.data.email);
      });
  }, []);

  const deleteAccount = () => {
    axios
      .delete(`${API_URL}/users/${userId}`)
      .then(() => {})
      .catch((error) => {
        console.log(error);
      });
    navigate("/login");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userId");
  };

  return (
    <>
      <Header />

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          height: "100vh",
          width: "100vw",
        }}
      >
        <Card
          style={{
            marginBottom: "7rem",
            width: "300px",
            height: "400px",
            borderRadius: "10px",
            boxShadow: "0 0 5px 2px rgba(0, 0, 0, .3)",
          }}
        >
          <Flex
            mih={50}
            gap="xl"
            justify="flex-start"
            align="flex-start"
            direction="column"
            wrap="wrap"
          >
            <Image
              style={{ marginLeft: "5rem" }}
              radius="xl"
              width={100}
              height={100}
              src={
                "default.jpg"
              }
            />
            <Text size="xl">
              <strong>Name:</strong>
            </Text>
            <Text style={{ marginTop: "-1.6rem" }}>{`${name}`}</Text>
            <Text size="xl">
              <strong>Email:</strong>
            </Text>
            <Text style={{ marginTop: "-1.6rem" }}>{`${email}`}</Text>
            <Link to="/updatePassword">
              <Text size="xl">Update Password?</Text>
            </Link>
            <Button
              className="w-100"
              style={{}}
              color="red"
              onClick={deleteAccount}
            >
              Delete Account
            </Button>
          </Flex>
        </Card>
      </div>
    </>
  );
}

export default withAuth(ProfilePage);
